import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useEvents = () => {
    const [events, setEvents] = useState(null);
    const load = () =>
        api
            .get("/events")
            .then((r) => setEvents(r.data))
            .catch(() => setEvents([]));
    useEffect(() => {
        load();
    }, []);
    return { events, reload: load };
};
